import Spline from "@splinetool/react-spline";
import Image from "next/image";
import { ReactNode } from "react";

import { usePerformance } from "@hooks";
import { WorkingArea } from "@utils";

import { SpeciazlizationColoredSpan } from "./Specializations.styled";

interface SpecializationInlineProps {
  splineCodeSrc: string;
  fallbackSrc: string;
  colorKey: WorkingArea;
  children?: ReactNode;
}

export const SpecializationInline = ({
  splineCodeSrc,
  colorKey,
  children,
  fallbackSrc,
}: SpecializationInlineProps) => {
  const { splineSupport } = usePerformance();

  const sharedStyle = {
    height: "20px",
    width: "20px",
    display: "inline-block",
    marginBottom: "-3px",
    marginLeft: "6px",
    marginRight: "6px",
  };

  return (
    <span className="whitespace-nowrap">
      {splineSupport ? (
        <Spline
          style={sharedStyle}
          scene={splineCodeSrc}
          onLoad={scene => scene.setZoom(1.5)}
        />
      ) : (
        <Image
          src={fallbackSrc}
          width={Number(sharedStyle.width.replace("px", ""))}
          height={Number(sharedStyle.height.replace("px", ""))}
          alt=""
          style={sharedStyle}
        />
      )}
      <SpeciazlizationColoredSpan colorKey={colorKey}>
        {children}
      </SpeciazlizationColoredSpan>
    </span>
  );
};
